import { render, staticRenderFns } from "./viewReviewOpinions.vue?vue&type=template&id=4ac15e9d&scoped=true&"
import script from "./viewReviewOpinions.vue?vue&type=script&lang=js&"
export * from "./viewReviewOpinions.vue?vue&type=script&lang=js&"
import style0 from "./viewReviewOpinions.vue?vue&type=style&index=0&id=4ac15e9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac15e9d",
  null
  
)

export default component.exports